import { Show } from "shared/components";
import {
  DataVendors,
  RetryIdentityVerificationStatus,
  Verification,
  VerificationNames
} from "shared/types";
import { Applicant } from "types/application";
import { Loading02 } from "untitledui-js-base";

const getIdentityVerificationMessage = (applicant?: Applicant): string => {
  if (
    applicant?.retry_identity_verification_status ===
    RetryIdentityVerificationStatus.InProgress
  )
    return "Identity verification retry is in progress. Please wait";

  return "Report in progress. Please wait";
};

interface ProcessingReportViewProps {
  currentVerification: Verification;
  className?: string;
  applicant?: Applicant;
}

export const ProcessingReportView = ({
  currentVerification,
  applicant
}: ProcessingReportViewProps) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-warning-50">
          <Loading02 size="20px" className="stroke-warning-500" />
        </div>

        <div className="flex flex-col gap-2">
          <Show
            if={
              currentVerification.name ===
              VerificationNames.IdentityVerification
            }
          >
            {applicant?.retry_identity_verification_status ===
            RetryIdentityVerificationStatus.Pending ? (
              <p className="text-center text-sm text-content-300 w-full max-w-[432px]">
                A request to retry identity verification has been sent to the
                applicant. You can copy and resend the retry link at any time
              </p>
            ) : (
              <p className="text-center font-bold text-content-500">
                {getIdentityVerificationMessage(applicant)}
              </p>
            )}
          </Show>

          <Show
            if={[
              VerificationNames.CriminalReport,
              VerificationNames.EvictionReport
            ].includes(currentVerification.name)}
          >
            <p className="text-center font-bold text-content-500">
              Report in progress. Please wait
            </p>

            <Show if={currentVerification.vendor === DataVendors.CIC}>
              <p className="text-content-300 text-sm text-center">
                This applicant requires a manual review by our team. Check back
                in 24 hours
              </p>
            </Show>
          </Show>

          <Show
            if={[VerificationNames.VerifiedIncomeVerification].includes(
              currentVerification.name
            )}
          >
            <p className="text-center font-bold text-content-500">
              Verifying income...
            </p>

            <p className="text-content-300 text-sm text-center">
              We are verifying income using the method selected by the applicant
            </p>
          </Show>
        </div>
      </div>
    </div>
  );
};
